/* 
--- DEVELOPER WARNING ---
This is a generated file.
Any changes you make to this file will not be saved nor git tracked. 
*/

import poseBody_IconURL from './pose-body.png';
import poseBody_InsetIconURL from './pose-body-small.svg';
import React from 'react';
import { FormattedMessage } from 'react-intl';
export default {
	name: 
  (
    <FormattedMessage
        defaultMessage="Body Sensing"
        description="name for the Body Sensing extension"
        id="extension.poseBody.name"
    />
  ),
	description: 
  (
    <FormattedMessage
        defaultMessage="Sense body position with the camera."
        description="description for the Body Sensing extension"
        id="extension.poseBody.description"
    />
  ),
	iconURL: poseBody_IconURL,
	insetIconURL: poseBody_InsetIconURL,
	tags: ["Dancing with AI","Made by PRG"],
	featured: true,
	extensionId: 'poseBody',
}